import { Colors } from '@sigma-frontend-libs/commons'

import { sizes } from '@/utils'

import { baseClass } from '@/components/rules/utils'
import tag from '@/components/tag'

export default function(h) {
  return h(
    'div',
    {
      class: `${baseClass}-item__holder-value`
    },
    [
      h(
        tag,
        {
          props: {
            label: this.label,
            color: Colors.primary,
            loading: this.loading,
            size: sizes.small
          }
        }
      )
    ]
  )
}
